import * as tslib_1 from "tslib";
import { ContentContainer } from './content_container';
var PlainContainer = /** @class */ (function (_super) {
    tslib_1.__extends(PlainContainer, _super);
    function PlainContainer(param) {
        return _super.call(this, param) || this;
    }
    PlainContainer.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "PlainContainer" });
    };
    PlainContainer.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return PlainContainer;
}(ContentContainer));
export { PlainContainer };
//# sourceMappingURL=plain_container.js.map